const emailRegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const appVersionExp = /^\d+\.\d+\.\d+$/;
const RoleNames = {
  'Super Admin': 'Super Admin',
  Finance: 'Finance',
  Support: 'Support',
  'Verification Team': 'Verification Team',
};

const isNumber = (value) => !Number.isNaN(Number(value));

const Constants = {
  admin: {
    role: {
      superAdmin: 'Super Admin',
      finance: 'Finance',
      support: 'Support',
      verificationTeam: 'Verification Team',
    },
  },
  ticket: {
    type: {
      verification: 'Verification',
      depositWithdrawal: 'Deposit/Withdrawal',
      other: 'Other Issue',
    },
    status: {
      pending: 'Pending',
      answered: 'Answered',
      resolved: 'Resolved',
    },
  },
};

const TIMEZONE = 'Asia/Kolkata';
const TIMEZONE_NAME = 'IST';

export { emailRegExp, RoleNames, isNumber, Constants, appVersionExp, TIMEZONE, TIMEZONE_NAME };
